module.exports = __webpack_public_path__ + "static/media/portfolio.31262071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/menu/portfolio.jpg
// module id = 155
// module chunks = 0